
$(document).ready(function () {

    'use strict';

    // =========================================================
    // FLOATING WIDGET SCROLL BEHAVIOUR
    // =========================================================

    var scrollTimer = null;
    var lastScrollTop = $(window).scrollTop();
    var scrollThreshold = 8;
    var scrollIdleDelay = 1200;
    var widgetOpen = false;

    // Add animation styles
    if (!$('#postcode-scroll-animation-style').length) {
        $('head').append(`
            <style id="postcode-scroll-animation-style">

                .postcode-trigger {
                    transition:
                        opacity 0.35s ease,
                        transform 0.35s ease,
                        box-shadow 0.35s ease !important;
                    will-change: transform, opacity;
                }

                /* Subtle state while scrolling down */
                .postcode-trigger.postcode-scrolling {
                    opacity: 0.45;
                    transform: translateX(12px) scale(0.92);
                    box-shadow: 0 1px 4px rgba(0,0,0,0.06) !important;
                }

                /* Normal state */
                .postcode-trigger:not(.postcode-scrolling) {
                    opacity: 1;
                    transform: translateX(0) scale(1);
                }

                /* Restore on hover */
                .postcode-trigger.postcode-scrolling:hover,
                .postcode-trigger.postcode-scrolling:focus-visible {
                    opacity: 1;
                    transform: translateX(0) scale(1);
                }

                @media (max-width: 500px) {
                    .postcode-trigger.postcode-scrolling {
                        opacity: 0.4;
                        transform: translateX(8px) scale(0.9);
                    }
                }

                @media (prefers-reduced-motion: reduce) {
                    .postcode-trigger {
                        transition: none !important;
                    }
                }

            </style>
        `);
    }

    function restorePostcodeTrigger() {
        $('.postcode-trigger')
            .removeClass('postcode-scrolling');
    }

    function handlePostcodeScroll() {
        if (widgetOpen) return;

        var currentScrollTop = $(window).scrollTop();
        var scrollDifference = currentScrollTop - lastScrollTop;

        clearTimeout(scrollTimer);

        if (Math.abs(scrollDifference) >= scrollThreshold) {

            if (scrollDifference > 0 && currentScrollTop > 100) {
                // Scrolling down: reduce prominence
                $('.postcode-trigger')
                    .addClass('postcode-scrolling');
            } else if (scrollDifference < 0) {
                // Scrolling up: restore
                restorePostcodeTrigger();
            }

            lastScrollTop = currentScrollTop;
        }

        // Restore when user stops scrolling
        scrollTimer = setTimeout(function () {
            restorePostcodeTrigger();
        }, scrollIdleDelay);
    }

    $(window).on(
        'scroll.postcodeWidget',
        handlePostcodeScroll
    );

    // =========================================================
    // ANALYTICS
    // =========================================================

    function logPostcodeSearch(postcode, available, deliveryType) {
        $.ajax({
            url: ($('#postcodeForm').attr('data-search-proxy-url') ||
                '/apps/delivery/postcode') + '?postcode=' + encodeURIComponent(postcode),
            method: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            timeout: 12000,
            data: JSON.stringify({
                availability: available ? 'available' : 'unavailable',
                delivery_type: available ? deliveryType : 'none'
            })
        }).fail(function () {
            console.warn('Postcode search could not be saved.');
        });
    }

    // =========================================================
    // DELIVERY DATA
    // =========================================================

    function findDelivery(postcode) {
        if (
            typeof deliveries === 'undefined' ||
            !Array.isArray(deliveries)
        ) {
            console.error('deliveries.js is not loaded.');
            return null;
        }

        var code = String(postcode || '').trim();

        return deliveries.find(function (item) {
            return String(item.code).trim() === code;
        }) || null;
    }

    function getDeliveryDay(item) {
        return String((item && item.day) || '')
            .trim()
            .toLowerCase();
    }

    function formatDeliveryPrice(item) {
        if (
            !item ||
            item.price === null ||
            item.price === undefined ||
            item.price === ''
        ) {
            return null;
        }

        var price = Number(item.price);

        if (!Number.isFinite(price) || price < 0) {
            return null;
        }

        return '$' + price.toFixed(2);
    }

    // =========================================================
    // DELIVERY MESSAGE
    // =========================================================

    function getDeliveryMessage(item) {
        var price = formatDeliveryPrice(item);
        var day = getDeliveryDay(item);

        if (!price) return '';

        if (day === 'extended') {
            return `
                <strong>
                    Hooray! We deliver to your postcode!
                </strong>

                <div style="
                    color:#c62828;
                    font-weight:700;
                    margin:8px 0;
                ">
                    📅 FRIDAY DELIVERY ONLY
                </div>

                <div>
                    Delivery to your area is available
                    exclusively on Fridays.
                </div>

                <div style="margin-top:6px;">
                    Delivery fee is
                    <strong>${price}</strong>.
                </div>
            `;
        }

        return `
            <strong>
                Hooray! We deliver to your postcode!
            </strong>

            <div style="margin-top:6px;">
                Delivery fee is
                <strong>${price}</strong>.
            </div>
        `;
    }

    // =========================================================
    // OPEN FLOATING WIDGET
    // =========================================================

    $(document).on(
        'click',
        '.postcode-trigger',
        function () {

            widgetOpen = true;

            clearTimeout(scrollTimer);
            restorePostcodeTrigger();

            $('.postcode-trigger').hide();

            $('#postcodeOverlay').fadeIn(200);

            $('.postcode-panel')
                .stop(true, true)
                .fadeIn(180);

            setTimeout(function () {
                $('#deliveryPostcode').focus();
            }, 200);
        }
    );

    // =========================================================
    // CLOSE FLOATING WIDGET
    // =========================================================

    $(document).on(
        'click',
        '.postcode-close',
        function () {

            $('.postcode-panel')
                .stop(true, true)
                .fadeOut(150, function () {

                    widgetOpen = false;

                    restorePostcodeTrigger();

                    $('.postcode-trigger').fadeIn(150);
                    $('#postcodeOverlay').fadeOut(200);
                });
        }
    );

    // =========================================================
    // POSTCODE INPUT
    // =========================================================

    $(document).on(
        'input',
        '#deliveryPostcode',
        function () {

            this.value = this.value
                .replace(/\D/g, '')
                .slice(0, 4);

            $('#postcodeResult')
                .removeClass('success error')
                .hide();
        }
    );

    // =========================================================
    // POSTCODE FORM SUBMIT
    // =========================================================

    $(document).on(
        'submit',
        '#postcodeForm',
        function (e) {

            e.preventDefault();

            var postcode = $.trim(
                $('#deliveryPostcode').val()
            );

            var $result = $('#postcodeResult');

            $result
                .removeClass('success error')
                .empty();

            if (!/^\d{4}$/.test(postcode)) {
                $result
                    .addClass('error')
                    .text(
                        'Please enter a valid 4-digit postcode.'
                    )
                    .show();

                return;
            }

            if (
                typeof deliveries === 'undefined' ||
                !Array.isArray(deliveries)
            ) {
                $result
                    .addClass('error')
                    .text(
                        'We could not check delivery right now. Please try again later.'
                    )
                    .show();

                return;
            }

            var item = findDelivery(postcode);

            if (
                item &&
                formatDeliveryPrice(item) &&
                ['daily', 'extended'].includes(
                    getDeliveryDay(item)
                )
            ) {
                $result
                    .addClass('success')
                    .html(getDeliveryMessage(item))
                    .show();

                logPostcodeSearch(
                    postcode,
                    true,
                    getDeliveryDay(item)
                );

                return;
            }

            $result
                .addClass('error')
                .text(
                    'Sorry, we do not currently deliver to this postcode.'
                )
                .show();

            logPostcodeSearch(
                postcode,
                false,
                'none'
            );
        }
    );

});
